import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: "timePeriodPipe",
})
export class TimePeriodPipe implements PipeTransform {
  transform(timeDiff: number, format: string = "HH:mm:ss.SSS"): string {
    if (!timeDiff) {
      return this.formatTime(0, format);
    }

    const minus = timeDiff < 0;
    const absTimeDiff = Math.abs(timeDiff);

    const hours = Math.floor(absTimeDiff / (1000 * 60 * 60));
    const minutes = Math.floor((absTimeDiff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((absTimeDiff % (1000 * 60)) / 1000);
    const milliseconds = absTimeDiff % 1000;

    let result = format;
    result = result.replace("HH", this.setTwoDG(hours));
    result = result.replace("H", String(hours));
    result = result.replace("mm", this.setTwoDG(minutes));
    result = result.replace("m", String(minutes));
    result = result.replace("ss", this.setTwoDG(seconds));
    result = result.replace("s", String(seconds));
    result = result.replace("SSS", this.setThreeDG(milliseconds));

    if (minus) {
      result = `-${result}`;
    }

    return result;
  }

  private formatTime(timeDiff: number, format: string): string {
    let result = format;
    result = result.replace("HH", "00");
    result = result.replace("H", "0");
    result = result.replace("mm", "00");
    result = result.replace("m", "0");
    result = result.replace("ss", "00");
    result = result.replace("s", "0");
    result = result.replace("SSS", "000");
    return result;
  }

  private setTwoDG(num: number): string {
    const str = String(num);
    if (num < 10) {
      return `0${str}`;
    }
    return str;
  }

  private setThreeDG(num: number): string {
    const str = String(num);
    if (num < 10) {
      return `00${str}`;
    }
    if (num < 100) {
      return `0${str}`;
    }
    return str;
  }
}
